/* eslint-disable */
const convert = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});

export default {
  toBase64: async function(file) {
    var base64 = await convert(file);
    return base64.split(',')[1];
  }
}